package de.ohhhmhhh.frontend.admin.ui.screens.revocation

import androidx.compose.runtime.Composable
import de.ohhhmhhh.frontend.admin.navigation.Navigator

@Composable
fun RevocationListPage(
    viewModel: RevocationListViewModel,
    state: RevocationListState,
    navigator: Navigator
) {
    RevocationListPageContent(
        state = state,
        onSearch = viewModel::setSearch,
        onSetContractType = viewModel::setContractType,
        onSetState = viewModel::setState,
        onUpdateState = viewModel::updateState,
        onReset = viewModel::reset,
        onSetPage = viewModel::setPage
    )
}